var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "reporting-call-logs-header" }, [
      _c("h2", {
        directives: [
          {
            name: "t",
            rawName: "v-t",
            value: "HEADER_SEARCH_BIDS",
            expression: "'HEADER_SEARCH_BIDS'"
          }
        ],
        staticClass: "reporting-call-logs-header__title"
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "r-form display-flex flex--wrap p-b-15" },
      [
        _c("SearchableDropdown", {
          staticClass: "rtb-export-timezone m-r-15 m-b-15",
          attrs: {
            rules: "required",
            config: _vm.timeZoneOptions,
            clearable: false
          },
          model: {
            value: _vm.timeZoneId,
            callback: function($$v) {
              _vm.timeZoneId = $$v
            },
            expression: "timeZoneId"
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "r-form__input m-r-15 m-b-10 p-l-0" },
          [
            _c("ValidationProvider", {
              attrs: { rules: "required", slim: "" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ classes, errors }) {
                    return [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.bidId,
                            expression: "bidId"
                          }
                        ],
                        staticClass: "form-control",
                        class: classes,
                        attrs: {
                          size: "38",
                          type: "text",
                          placeholder: _vm.$t("INPUT_SEARCH_BIDS_PLACEHOLDER")
                        },
                        domProps: { value: _vm.bidId },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.bidId = $event.target.value
                          }
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "PrimaryButton",
          {
            staticClass: "p-l-15 m-b-15",
            class: _vm.isSearching ? "p-r-35" : "p-r-15",
            attrs: { "show-loader-on-form": _vm.isSearching, type: "button" },
            on: { click: _vm.onSearchRtbLog }
          },
          [
            _c("i", {
              staticClass: "fa fa-search p-r-0",
              attrs: { "aria-hidden": "true" }
            })
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "rtb-dashboard__rtb-log" },
      [
        _vm.bidRecord
          ? [
              _c("div", { staticClass: "grid_table_holder" }, [
                _c("table", { staticClass: "table_beauty" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th", { attrs: { width: "25" } }),
                      _vm._v(" "),
                      _c("th", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "CELL_BID_STATUS",
                            expression: "'CELL_BID_STATUS'"
                          }
                        ]
                      }),
                      _vm._v(" "),
                      _c("th", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "CELL_DT",
                            expression: "'CELL_DT'"
                          }
                        ]
                      }),
                      _vm._v(" "),
                      _c("th", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "CELL_WINNING_BID",
                            expression: "'CELL_WINNING_BID'"
                          }
                        ]
                      }),
                      _vm._v(" "),
                      _c("th", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "CELL_CAMPAIGN",
                            expression: "'CELL_CAMPAIGN'"
                          }
                        ]
                      }),
                      _vm._v(" "),
                      _c("th", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "CELL_PUBLISHER",
                            expression: "'CELL_PUBLISHER'"
                          }
                        ]
                      }),
                      _vm._v(" "),
                      _c("th", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "CELL_BID",
                            expression: "'CELL_BID'"
                          }
                        ]
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    [
                      _c("RtbRecordRow", {
                        attrs: {
                          bidRecord: _vm.bidRecord,
                          timeZoneId: _vm.translatedTimeZoneId
                        },
                        on: { "toggle-bid-details": _vm.toggleBidDetails }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "collapse",
                {
                  model: {
                    value: _vm.showBidDetails,
                    callback: function($$v) {
                      _vm.showBidDetails = $$v
                    },
                    expression: "showBidDetails"
                  }
                },
                [
                  _c("RtbRecordDetails", {
                    attrs: {
                      bidRecord: _vm.bidRecord,
                      timeZoneId: _vm.translatedTimeZoneId
                    }
                  })
                ],
                1
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        !_vm.bidRecord && _vm.hasSearchedBid && !_vm.isSearching
          ? _c("div", { staticClass: "rtb-dashboard__rtb-log-not-found" }, [
              _c("p", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "BID_RECORD_NOT_FOUND",
                    expression: "'BID_RECORD_NOT_FOUND'"
                  }
                ],
                staticClass: "m-b-0"
              })
            ])
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }